<template>
    <div class="row-fill container-col">
      <h1 class="row-fit">
        آخر التعديلات
      </h1>
      <div class="row-fill default-padding" v-infinite-scroll="loadMoreChanges" infinite-scroll-disabled="busy"
           infinite-scroll-distance="10">
        <div v-for="gc of groupedChanges" :key="gc.date">
          <h2> {{ gc.date }} </h2>
          <div v-for="(c, n) of gc.changes" :key="n" class="change">
            <span class="timestamp"> {{ c.time }}: </span>
            <span v-if="c.type==='rate_collocation'">
              تم تقييم المتواردة اللفظية
              <router-link :to="{ name: 'collocation', params: { lempos: c.params.lempos.split(' ')[0], collLempos: c.params.lempos, collPattern: c.params.pattern } }">
                {{ lempos2lemma(c.params.lempos) }}
              </router-link>
              ({{ c.params.pattern }})
              بأنها
              <span v-if="c.params.rating===true"> صحيحة </span>
              <span v-else> غير صحيحة </span>
            </span>
            <span v-else-if="c.type==='rate_instance'">
              تم تقييم مثل للمتواردة اللفظية
              <router-link :to="{ name: 'collocation', params: { lempos: c.params.lempos.split(' ')[0], collLempos: c.params.lempos, collPattern: c.params.pattern } }">
                {{ lempos2lemma(c.params.lempos) }}
              </router-link>
              بأنه
              <span v-if="c.params.rating===true"> صحيحة </span>
              <span v-else> غير صحيحة </span>
            </span>
            <span v-else-if="c.type==='update_semantic_groups'">
              تم تصنيف المتواردة اللفظية لـ
              <router-link :to="{ name: 'lemma', params: { lempos: c.params.lempos } }">
                {{ lempos2lemma(c.params.lempos) }}
              </router-link>
            </span>
            <span v-if="c.user"> من قبل {{ c.user }} </span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { api } from '../mixins/api.js'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'ChangesView',
  mixins: [api],
  directives: { infiniteScroll },
  data: function () {
    return {
      changes: [],
      busy: false,
      noDataRemaining: false
    }
  },
  props: {
  },
  components: {
  },
  computed: {
    groupedChanges: function () {
      return this.changes.reduce(function (rv, x) {
        let d = new Date(x['timestamp'])
        let date = d.toLocaleDateString('ar-SY', { day: 'numeric', month: 'long', year: 'numeric' })
        x.time = d.toLocaleTimeString('ar-SY')
        let el = rv.find((r) => r && r.date === date)
        if (el) {
          el.changes.push(x)
        } else {
          rv.push({ date, changes: [x] })
        }
        return rv
      }, [])
    }
  },
  methods: {
    loadMoreChanges: function () {
      if (this.noDataRemaining) { return }
      console.log('Getting more changes ...')
      let ts = this.changes.length ? this.changes[this.changes.length - 1].timestamp : null
      var t = this
      this.getChanges(30, ts).then(function (response) {
        console.log('Got ' + response.data.length + ' more changes: ')
        if (response.data.length) {
          t.changes.push(...response.data)
        } else {
          t.noDataRemaining = true
        }
      })
    }
  },
  created: function () {
    // this.loadMoreChanges()
  }
}
</script>

<style scoped>
div.change {
  margin-bottom: 3px
}
span.timestamp {
  color: grey
}
h2 {
  margin-top: 15px;

}
</style>
